export default __webpack_public_path__ + "static/media/photo--sm--kickoff1b.e170ea64.jpg";